class ColorTheme {
    #color;
    static CORAL = new ColorTheme('coral');
    static GREEN = new ColorTheme('green');
    static GRAY = new ColorTheme('gray');
    static TRANSPARENT = new ColorTheme('transparent');

    constructor(props) {
        this.#color = props;
    }

    get color() {
        return this.#color;
    }

}

export default class Routes {
    #id;
    #color;
    static App = new Routes('app', ColorTheme.TRANSPARENT.color);

    // Page Templates
    static Home = new Routes('pageHome', ColorTheme.GRAY.color);
    static pageContact = new Routes('pageContact');
    static pageSpecs = new Routes('pageSpecs', ColorTheme.CORAL.color);
    static pageApp = new Routes('pageApp', ColorTheme.CORAL.color);
    static pageSources = new Routes('pageSources', ColorTheme.CORAL.color);
    static pageCompany = new Routes('pageCompany', ColorTheme.CORAL.color);
    static pageRegister = new Routes('pageRegister', ColorTheme.GRAY.color)

    // Archive templates
    static archiveKnowledgeRepository = new Routes('archiveKnowledgeRepository');
    static archivePackage = new Routes('archivePackage', ColorTheme.GREEN.color);
    static archiveProject = new Routes('archiveProject', ColorTheme.CORAL.color);
    static archiveEvent = new Routes('archiveEvent', ColorTheme.GRAY.color);
    static archiveNews = new Routes('archiveNews', ColorTheme.GRAY.color);
    static archiveFaqRepository = new Routes('archiveFaqRepository');
    static archiveGlossaryRepository = new Routes('archiveGlossaryRepository');
    static taxonomyIndustry = new Routes('taxonomyIndustry', ColorTheme.GRAY.color);

    // Single Templates
    static singleEvent = new Routes('singleEvent');
    static singlePackage = new Routes('singlePackage', ColorTheme.GREEN.color);
    static singleProject = new Routes('singleProject');
    static singleKnowledgeRepository = new Routes('singleKnowledgeRepository');
    static singleFaqRepository = new Routes('singleFaqRepository');
    static singleNews = new Routes('singleNews', ColorTheme.GRAY.color);

    // Error
    static error404 = new Routes('error404');

    constructor(id, color) {
        this.#colorScheme = color;
        this.#id = id;
    }

    set #colorScheme(value) {
        if (typeof value !== 'undefined' && typeof value === 'string') {
            this.#color = value;
        } else {
            this.#color = 'default';
        }
    }

    get id() {
        return this.#id;
    }

    get element() {
        return document.getElementById(this.#id);
    }

    get color() {
        return this.#color;
    }

    static getRouteByColor(color) {
        return Object.values(Routes).find(instance => instance.color === color && instance.element !== null);
    }
}
